// React
import React, { useEffect } from 'react';

// Packages
import t from 'prop-types';
import cc from 'classcat';
import _camelCase from 'lodash.camelcase';

// Utilities

import { useLayoutStore, useDashboardStore } from 'utilities/store';
import { useResponsive } from 'utilities/hooks';

const DashboardLayoutComponent = ({ children }) => {
    // ///////////////////
    // STORES
    // ///////////////////

    const {
        setSecondaryNavigationActive,
        setSecondaryNavigationAnimationOnly,
        setMainNavigationWide,
        setMainNavigationActive,
    } = useLayoutStore();

    const { initiativesLoaded } = useDashboardStore();

    // ///////////////////
    // HOOKS
    // ///////////////////

    const bp = useResponsive();

    // ///////////////////
    // DATA
    // ///////////////////

    const smallBps = ['2xs', 'xs', 'sm', 'md'];
    const largeBps = ['lg', 'xl', '2xl', '3xl'];

    // ///////////////////
    // EFFECTS
    // ///////////////////

    useEffect(() => {
        if (initiativesLoaded) {
            setMainNavigationWide(false);
            setSecondaryNavigationActive(true);
            setSecondaryNavigationAnimationOnly(false);
        } else {
            setMainNavigationWide(false);
            setSecondaryNavigationActive(false);
        }
        setSecondaryNavigationAnimationOnly(false);
    }, [initiativesLoaded]);

    useEffect(() => {
        if (initiativesLoaded) {
            if (smallBps.includes(bp)) {
                setSecondaryNavigationActive(false);
                setMainNavigationActive(false);
            }
            if (largeBps.includes(bp)) {
                setSecondaryNavigationActive(true);
                setMainNavigationActive(true);
            }
        }
    }, [bp, initiativesLoaded]);

    // ///////////////////
    // RENDER
    // ///////////////////

    return (
        <>
            <div
                className={cc([
                    'mt-header pt-80',
                    {
                        'lg:ml-nav-combined': initiativesLoaded,
                    },
                ])}>
                <div
                    className={cc([
                        'page-mx',
                        {
                            'max-w-[1400px]': initiativesLoaded,
                        },
                    ])}>
                    {children}
                </div>
            </div>
        </>
    );
};

DashboardLayoutComponent.propTypes = {
    pageProps: t.object,
};

DashboardLayoutComponent.defaultProps = {
    pageProps: {},
};

export default DashboardLayoutComponent;
